(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Borde de la cabecera al hacer scroll
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Cerrar el menú móvil al pulsar un enlace
  document.querySelectorAll('.mobile-nav a').forEach(function (link) {
    link.addEventListener('click', function () {
      var details = link.closest('details');
      if (details) details.removeAttribute('open');
    });
  });

  // Barra fija de compra: visible tras la portada y oculta cuando el bloque de compra está a la vista
  var bar = document.querySelector('[data-sticky-buy]');
  var target = document.querySelector('[data-buy-target]');
  var hero = document.querySelector('.hero') || document.querySelector('.pdp');
  if (bar && 'IntersectionObserver' in window) {
    bar.removeAttribute('hidden');
    var heroVisible = true;
    var targetVisible = false;
    var update = function () { bar.classList.toggle('is-visible', !heroVisible && !targetVisible); };
    if (hero) {
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting; update();
      }, { threshold: 0 }).observe(hero);
    } else { heroVisible = false; }
    if (target && target !== hero) {
      new IntersectionObserver(function (entries) {
        targetVisible = entries[0].isIntersecting; update();
      }, { threshold: 0.15 }).observe(target);
    }
    update();
  }

  // Selectores de cantidad (− / +)
  function clamp(input, value) {
    var min = parseInt(input.min || '0', 10);
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    if (isNaN(value)) value = min;
    return Math.min(max, Math.max(min, value));
  }
  function refreshButtons(qty) {
    var input = qty.querySelector('[data-qty-input]');
    var value = parseInt(input.value, 10);
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    if (minus) minus.disabled = value <= parseInt(input.min || '0', 10);
    if (plus) plus.disabled = input.max ? value >= parseInt(input.max, 10) : false;
  }
  document.querySelectorAll('[data-qty]').forEach(function (qty) {
    var input = qty.querySelector('[data-qty-input]');
    var step = function (delta) {
      input.value = clamp(input, parseInt(input.value, 10) + delta);
      refreshButtons(qty);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
    input.addEventListener('blur', function () { input.value = clamp(input, parseInt(input.value, 10)); refreshButtons(qty); });
    refreshButtons(qty);
  });

  // Carrito: al cambiar una cantidad, se actualiza solo
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var updateButton = cartForm.querySelector('[data-cart-update]');
    if (cartForm.requestSubmit) cartForm.classList.add('js-cart');
    var timer;
    cartForm.querySelectorAll('[data-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          cartForm.classList.add('is-updating');
          if (cartForm.requestSubmit && updateButton) cartForm.requestSubmit(updateButton);
          else if (updateButton) updateButton.click();
        }, 450);
      });
    });
  }

  // Contador del carrito en la cabecera
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
    document.querySelectorAll('[data-cart-link]').forEach(function (el) {
      el.setAttribute('aria-label', 'Ver carrito (' + count + (count === 1 ? ' producto)' : ' productos)'));
    });
  }

  // Aviso flotante tras añadir al carrito
  function toast(message) {
    var el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = '<span>' + message + '</span><a class="toast__link" href="' + root + 'cart">Ver carrito</a>';
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 5000);
  }

  // ---- Carrito: utilidades ----
  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function findLine(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === String(variantId)) return cart.items[i];
    }
    return null;
  }
  function addItem(variantId, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r; });
  }
  function setLineQty(line, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error('change'); return r; });
  }
  // Deja en el carrito exactamente "qty" unidades de la guía (sin acumular intentos anteriores)
  function setQuantity(variantId, qty) {
    return getCart().then(function (cart) {
      var line = findLine(cart, variantId);
      if (!line) return addItem(variantId, qty);
      if (line.quantity === qty) return null;
      return setLineQty(line, qty);
    });
  }
  // Se asegura de que la guía esté en el carrito (al menos 1 unidad)
  function ensureInCart(variantId) {
    return getCart().then(function (cart) {
      return findLine(cart, variantId) ? null : addItem(variantId, 1);
    });
  }
  function busy(button, on) {
    if (!button) return;
    button.disabled = on;
    if (on) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
  }
  function goToCart() { window.location.href = root + 'cart'; }

  // ---- Formularios de compra en la página de producto y en la portada ----
  document.querySelectorAll('[data-buy-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.fetch) return; // sin soporte: envío normal del formulario (va al carrito)
      event.preventDefault();
      var submitter = event.submitter;
      var buyNow = !submitter || submitter.hasAttribute('data-buy-now');
      var variantId = form.querySelector('input[name="id"]').value;
      var qtyInput = form.querySelector('[data-qty-input]');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      busy(submitter, true);
      setQuantity(variantId, qty)
        .then(function () {
          if (buyNow) { goToCart(); return; }
          return getCart().then(function (cart) {
            setCartCount(cart.item_count);
            toast(qty === 1 ? 'Guía añadida al carrito.' : qty + ' guías en el carrito.');
            busy(submitter, false);
          });
        })
        .catch(function () {
          busy(submitter, false);
          var hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = 'return_to'; hidden.value = root + 'cart';
          form.appendChild(hidden);
          form.submit();
        });
    });
  });

  // ---- Botón «Comprar ya» del catálogo: añade la guía (si no está) y abre el carrito ----
  document.querySelectorAll('[data-quick-buy]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.fetch) return;
      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      busy(button, true);
      ensureInCart(form.querySelector('input[name="id"]').value)
        .then(goToCart)
        .catch(function () { busy(button, false); form.submit(); });
    });
  });

  // ---- Consentimiento en el carrito: aviso visible si no se marca ----
  document.querySelectorAll('.consent input[type="checkbox"]').forEach(function (box) {
    var label = box.closest('.consent');
    box.addEventListener('invalid', function () {
      label.classList.add('is-invalid');
      label.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    box.addEventListener('change', function () {
      if (box.checked) label.classList.remove('is-invalid');
    });
  });
})();
